module.exports = __webpack_public_path__ + "static/img/200265.364a837e.png";